import axios from "axios";
const BASE = "https://wigrpkuspc.execute-api.ap-south-1.amazonaws.com";

export const loansToday = () => axios.get(`${BASE}/loans/today`);
export const loansYesterday = () => axios.get(`${BASE}/loans/yesterday`);
export const loansLast7 = () => axios.get(`${BASE}/loans/last7`);
export const loansLast30 = () => axios.get(`${BASE}/loans/last30`);

export const loansMonthlyRange = (body) =>
  axios.post(`${BASE}/loans/monthly/range`, body);
